export default __webpack_public_path__ + "static/media/1440px-360px-Scrub-Sky-Turbines-Hero-Large.jpg.9813ac12.webp";